import React from 'react'
import { YAxis } from 'recharts'
import { useMediaQuery, useTheme } from '@mui/material'
import { AxisDomain } from 'recharts/types/util/types'
import { UnitTypes } from 'src/Libs/types'

interface Props {
  isModal: boolean
  yAxisDomain: AxisDomain
}

const YAxisPowerPriceChart: React.FC<Props> = ({ isModal, yAxisDomain }) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const tickLabelMargin = -Number.parseInt(theme.spacing(2))
  const YAxisPaddingLeft = -Number.parseInt(theme.spacing(1))

  return (
    <YAxis
      dataKey="price"
      domain={yAxisDomain}
      scale="linear"
      axisLine={false}
      tickLine={false}
      mirror
      allowDataOverflow
      hide={!isModal}
      dy={tickLabelMargin}
      dx={YAxisPaddingLeft}
      tickFormatter={downSm ? formatYAxisTicksDownSm : formatYAxisTicksDefault}
      label={{
        value: `${UnitTypes.centsPerKiloWattHour}`,
        position: 'top',
        offset: theme.space(3),
        style: { fontSize: 11 },
      }}
      style={{
        fontSize: 11,
      }}
    />
  )
}

export default YAxisPowerPriceChart

/** Helper functions to format Y-axis ticks */

const formatYAxisTicksDownSm = (value: string): string => {
  if (Number(value) % 2 === 0) {
    return value
  }
  return ''
}

const formatYAxisTicksDefault = (value: string): string => value
